import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const serviceRequestCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        // If the account supports service requests, they're always allowed
        return true;
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        return isServiceRequestSupportedForMailbox(mailboxInfo);
    },
};
